import {
    GET_PARTICIPANTS, SET_BILLING_DETAIL,
    SET_CURRENT_PARTICIPANT,
    SET_DSO_DETAILS,
    SET_ENEDIS_DETAIL,
    SET_PARTICIPANTS, UPDATE_CURRENT_PARTICIPANT_BILLING_DETAIL,
    UPDATE_CURRENT_PARTICIPANT_DSO_DETAILS,
    UPDATE_CURRENT_PARTICIPANT_ENEDIS_DETAIL,
} from "./participantsConstants";
import {EParticipant} from "../../models/entities/participant/participant";
import {EnedisDetail} from "../../models/entities/participant/enedisDetail";
import {BillingDetail} from "../../models/entities/participant/billingDetail";
import { DsoDetails } from '../../models/entities/participant/dsoDetails';

export let ParticipantsActions = {

    updateCurrentParticipantDsoDetails(dsoDetails : DsoDetails | null) {
        return {type : UPDATE_CURRENT_PARTICIPANT_DSO_DETAILS, payload:{dsoDetails}}
    },
    updateCurrentParticipantEnedisDetail(enedisDetail : EnedisDetail | null) {
        return {type : UPDATE_CURRENT_PARTICIPANT_ENEDIS_DETAIL, payload:{enedisDetail}}
    },
    updateCurrentParticipantBillingDetail(billingDetail : BillingDetail | null){
        return {type : UPDATE_CURRENT_PARTICIPANT_BILLING_DETAIL, payload:{billingDetail}}
    },
    getParticipants() {
        return {type: GET_PARTICIPANTS};
    },
    setParticipants(participants: EParticipant[] | null) {
        return {type: SET_PARTICIPANTS, payload: {participants}};
    },
    setCurrentParticipant(currentParticipant: EParticipant | null) {
        return {type: SET_CURRENT_PARTICIPANT, payload: {currentParticipant}};
    },
    setDsoDetails(dsoDetailsUpdated : DsoDetails |null) {
        return{type: SET_DSO_DETAILS, payload: {dsoDetailsUpdated}};
    },
    setEnedisDetail(enedisDetailUpdated : EnedisDetail |null) {
        return{type: SET_ENEDIS_DETAIL, payload: {enedisDetailUpdated}};
    },
    setBillingDetail(billingDetailUpdated : BillingDetail |null) {
        return{type: SET_BILLING_DETAIL, payload: {billingDetailUpdated}};
    },

}

